<app-category-filter></app-category-filter>
<p-divider></p-divider>
<div *ngIf="categoryStore.asFlatTree() as categories">
  <p-pickList
    #listPickerCtrl
    [source]="categories"
    [target]="selected"
    sourceHeader="Bereiche"
    targetHeader="Auswahl"
    [dragdrop]="true"
    [responsive]="true"
    [showSourceControls]="showSourceControls"
    [showTargetControls]="showTargetControls"
    (onMoveToSource)="updateSelection()"
    (onMoveToTarget)="updateSelection()"
    (onMoveAllToSource)="updateSelection()"
    (onMoveAllToTarget)="updateSelection()"
    (onSourceSelect)="checkForSelectionHooks($event)"
    [sourceStyle]="{ height: '30rem' }"
    [targetStyle]="{ height: '30rem' }"
    breakpoint="1400px">
    <ng-template let-category pTemplate="item">
      <div class="flex-1 flex flex-column gap-2">
        <div class="flex align-items-center gap-2 text-lg">
          <i class="fas fa-folder"></i>
          <span>
            {{ category.name }}
          </span>
        </div>

        <div *ngIf="category.parent" class="flex align-items-center gap-2">
          <p-tag
            [rounded]="true"
            icon="fas fa-folder"
            styleClass="p-tag-category"
            [value]="categoryStore.getPathById(category.parent)"></p-tag>
        </div>
      </div>
    </ng-template>
  </p-pickList>
</div>
